
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/abonnement",
      function () {
        return require("private-next-pages/abonnement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/abonnement"])
      });
    }
  